exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "*,:after,:before{box-sizing:border-box}html{overflow-y:auto}body,html{height:100%}body{color:#333;font-family:Roboto,sans-serif;margin:0}h1,h2,h3,h5{font-family:Montserrat,sans-serif;text-transform:uppercase;font-weight:600;padding:0 15px}p{line-height:1.5}p a{color:inherit;cursor:pointer}strong a{font-weight:600}#app{display:flex;height:100%;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dc8b09e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 58
// module chunks = 0